import { Chip, Stack } from "@mui/material";

type TagsListProps = {
  value: string[];
};

const ChipTagsList = ({ value }: TagsListProps) => {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {value.length > 0
        ? value.map((tag) => <Chip label={tag} key={tag} />)
        : "N/A"}
    </Stack>
  );
};

export default ChipTagsList;
